/* istanbul ignore file */

import { ROOT_DOMAIN } from './environment';

// START GENAI@GHCOPILOT
const sdkScriptRegex =
  /^https:\/\/[\w-\.]+\.?\.visa\.com\/checkout\-widget\/resources\/js\/src-i-adapter\/visa[\-]{0,1}[s|S]{1}dk\.js/;
// END GENAI@GHCOPILOT

// START GENAI@GHCOPILOT
// This function is used to determine the sdk script tag of visa-sdk.js or visaSdk.js
// END GENAI@GHCOPILOT
function getSDKScriptEl() {
  const scripts = document.querySelectorAll('script');

  for (const script of scripts) {
    if (script.src && typeof script.src === 'string' && script.src.match(sdkScriptRegex)) {
      return script;
    }
  }

  return null;
}

// START GENAI@GHCOPILOT
// see src/common/get-stepup-domain.ts
// From the sdk script tag, we can determine the clicktopay environment url
const assetsMap = {
  '//assets.secure.checkout.visa.com': '//clicktopay.auth.visa.com',
  '//cert-assets.secure.checkout.visa.com': '//cert.clicktopay.auth.visa.com',
  '//cert.secure.checkout.visa.com': '//cert.clicktopay.auth.visa.com',
  '//sandbox-assets.secure.checkout.visa.com': '//sandbox.clicktopay.auth.visa.com',
  '//sandbox.secure.checkout.visa.com': '//sandbox.clicktopay.auth.visa.com',
  '//secure.checkout.visa.com': '//clicktopay.auth.visa.com'
};

function mapAssetsUrl(url: string) {
  const assetDomains = Object.keys(assetsMap) as Array<keyof typeof assetsMap>;
  // START GENAI@GHCOPILOT

  for (const assetDomain of assetDomains) {
    if (url.indexOf(assetDomain) !== -1) {
      return url.replace(assetDomain, assetsMap[assetDomain]);
    }
  }

  // default to BAU root domain
  return ROOT_DOMAIN;
  // END GENAI@GHCOPILOT
}

// START GENAI@GHCOPILOT
// This function is used to determine the clicktopay environment url
// END GENAI@GHCOPILOT
export default function getStepupDomain() {
  // In container deployments, the dummy url may not have been replaced. In this
  // case we need to determine the environment url from the visaSdk.js script tag.
  const sdkScriptEl = getSDKScriptEl();

  if (sdkScriptEl) {
    return mapAssetsUrl(sdkScriptEl.src.split('/', 3).join('/'));
  }

  // Default to BAU root domain
  return ROOT_DOMAIN;
}
